const cart = (function () {
  function init() {
    var timeout_N = 0;
    jQuery("document").ready(() => {
      jQuery("span.num.down").click(function () {
        var input = jQuery(this).siblings()[0];
        if (input.value == 1) {
          jQuery(
            jQuery(input).parents(".cart-items__row").find(".remove-from-cart")
          )[0].click();
        }
      });

      jQuery("span.num").click(function () {
        clearTimeout(timeout_N);
        timeout_N = setTimeout(() => {
          jQuery(".cart-form").submit();
        }, 500);
      });
    });
  }

  const loaded = document.readyState !== "loading";
  if (loaded) {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
    document.addEventListener("byoo:loaded", init);
  }
  let removeBtns = document.querySelectorAll('.remove-from-cart');
  if (removeBtns) {
      for (let i = 0, total = removeBtns.length; i < total; i++) {
          removeBtns[i].addEventListener('click', removeFromCart);
      }
  }

  return {
    wrap: init,
  };
})();
